import { Route, Routes } from 'react-router';
import Enum from './enum';
import List from './List';
import Add from './Add';
import Show from './show';

const Notifications = () => {
  // const urlParams = useParams();
  return (
    <Routes>
      {/* <Route path={`/send-notification`} element={<Add />} /> */}
      <Route path={`/notification`} element={<List />} />
      <Route path={`/notification/:id`} element={<Show />} />
    </Routes>
  );
};

export default Notifications;
